




































import Vue, { PropType } from 'vue';
import { AnotherVariant } from './types';
import Block from './Block.vue';
import SvgIcon from '../SvgIcon/SvgIcon.vue';
import SectionHeading from './SectionHeading.vue';

export default Vue.extend({
    components: {
        Block,
        SvgIcon,
        SectionHeading,
    },
    props: {
        data: Array as PropType<AnotherVariant[]>,
    },
});
